import React from "react"
import glamorous from "glamorous"

export default ({ ...props }) => (
  <FormWrapper onSubmit={props.onSubmit}>{props.children}</FormWrapper>
)

const FormWrapper = glamorous.form({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
})



// WEBPACK FOOTER //
// ./src/components/Form/FormFields/FormWrapper/index.js